import React from 'react'
import { Button, Dialog, Typogaphy } from 'vnetwork-ui'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { useForm } from 'react-hook-form'
import { cancelledBusinessByID } from '@/modules/Business/services'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { FormItem } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface CancelledProps {
    open: boolean
    selectedBusinessId: number | null
    onClose: () => void
    refetchData: () => void
}
const cancleBussinessSchema = (t: TFunction<'business', undefined>) =>
    yup.object().shape({
        business_reason_cancelled: yup
            .string()
            .trim()
            .required(t('blank-errors')),
    })

const Cancelled: React.FC<CancelledProps> = ({
    open,
    selectedBusinessId,
    onClose,
    refetchData,
}) => {
    const { t } = useTranslation('business')
    const { mutateAsync: cancelBusiness } = useMutationWithHandler(
        {
            mutationFn: cancelledBusinessByID,
        },
        {
            reactQueryKeys: QUERY_KEYS.BUSINESS,
            successMessage: t('cancel-success'),
            onSuccess: () => {
                refetchData()
                onClose()
            },
        }
    )

    const { control, handleSubmit } = useForm({
        resolver: yupResolver(cancleBussinessSchema(t)),
    })

    const onSubmit = async (data: { business_reason_cancelled: string }) => {
        if (selectedBusinessId && data.business_reason_cancelled) {
            await cancelBusiness({
                business_id: selectedBusinessId,
                business_reason_cancelled: data.business_reason_cancelled,
            })
        }
    }

    return (
        <Dialog open={open} onClose={onClose} title={t('business-cancel')}>
            <Typogaphy size="small">
                {t('description-confirm')}{' '}
                <span className="text-blue-400">
                    [IBN - {selectedBusinessId}]
                </span>{' '}
                {t('description-confirm1')}
            </Typogaphy>

            <form onSubmit={handleSubmit(onSubmit)}>
                <FormItem
                    control={control}
                    name="business_reason_cancelled"
                    type="textarea"
                    placeholder={t('reason-cancel')}
                    className="mt-4"
                />
                <div className="flex justify-end mt-4 gap-4">
                    <Button size="small" variant="outlined" onClick={onClose}>
                        {t('cancle-operation')}
                    </Button>
                    <Button variant="contained" type="submit">
                        {t('confirm')}
                    </Button>
                </div>
            </form>
        </Dialog>
    )
}

export default Cancelled
